import { Breadcrumb, Button, PageHeader } from 'antd';
import { FC } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import OrdersTable from '../components/tables/orders-table';
import SharpsmmServicesTable from '../components/tables/sharpsmm-services-table';

const SharpsmmServicesListRoute: FC = () => {
  const navigate = useNavigate()

  return (<>
    <PageHeader
        title="شارپ سوشیال"
      style={{ padding: " 16px 0" }}
      onBack={() => navigate(-1)}
      />
    <SharpsmmServicesTable />
  </>);
}

export default SharpsmmServicesListRoute;
